import moment from 'moment';

/**
 * Converts a UTC ISO date string (e.g. "2026-03-23T11:06:18.264Z")
 * to a formatted local timezone string (e.g. "11:06AM, 23 Mar 2026").
 * Returns the original string if parsing fails.
 */
export function formatUtcToLocal(utcDateStr?: string): string {
  if (!utcDateStr) {
    return '';
  }
  const m = moment.utc(utcDateStr).local();
  if (!m.isValid()) {
    return utcDateStr;
  }
  return m.format('h:mmA, DD MMM YYYY');
}
